module.exports = __webpack_public_path__ + "static/img/item-3-1.2b93bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-3-1.png
// module id = 0xfy
// module chunks = 2